(function () {
  'use strict';

  var containerSelector = '[data-cart-addons]';
  var addButtonSelector = '[data-cart-addon-add]';

  function getContainer() {
    return document.querySelector(containerSelector);
  }

  function updateVisibility(cart) {
    var container = getContainer();
    if (!container || !cart || typeof cart.total_price !== 'number') return;

    var thresholdEnabled = container.dataset.thresholdEnabled === 'true';
    var threshold = parseInt(container.dataset.threshold, 10) || 0;
    container.hidden = thresholdEnabled && cart.total_price >= threshold;
  }

  function announce(message) {
    var container = getContainer();
    var status = container && container.querySelector('[data-cart-addon-status]');
    if (status) status.textContent = message;
  }

  function cartUrl() {
    if (window.theme && theme.routes && theme.routes.cart) return theme.routes.cart;
    return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js';
  }

  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) return theme.routes.cartAdd;
    return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js';
  }

  function fetchCart() {
    return fetch(cartUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh the cart.');
      return response.json();
    });
  }

  function refreshVisibility() {
    fetchCart().then(updateVisibility).catch(function () {});
  }

  function setButtonLabel(button, text) {
    var label = button.querySelector('[data-cart-addon-label]');
    if (label) label.textContent = text;
  }

  function handleAdd(event) {
    var button = event.target.closest(addButtonSelector);
    if (!button || button.disabled || !button.closest(containerSelector)) return;

    event.preventDefault();
    var variantId = parseInt(button.dataset.variantId, 10);
    if (!variantId) return;

    var productTitle = button.dataset.productTitle || 'Product';
    var defaultLabel = button.dataset.defaultLabel || 'Add';
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (responseData) {
        return fetchCart().then(function (cart) {
          updateVisibility(cart);
          setButtonLabel(button, 'Added');
          announce(productTitle + ' added to cart.');

          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: cart }
          }));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: responseData, cart: cart }
          }));
        });
      })
      .catch(function (error) {
        var message = error && (error.description || error.message);
        announce(message || 'This product could not be added. Please try again.');
        setButtonLabel(button, 'Try again');
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        button.disabled = false;

        window.setTimeout(function () {
          setButtonLabel(button, defaultLabel);
        }, 1600);
      });
  }

  document.addEventListener('click', handleAdd);
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) updateVisibility(event.detail.cart);
    else refreshVisibility();
  });
  document.addEventListener('product-form:cart:update', function (event) {
    if (event.detail && event.detail.cart) updateVisibility(event.detail.cart);
    else refreshVisibility();
  });
  document.addEventListener('product-form:submit:success', function (event) {
    if (event.detail && event.detail.cart) updateVisibility(event.detail.cart);
    else refreshVisibility();
  });
  document.addEventListener('ajaxProduct:added', function (event) {
    if (event.detail && event.detail.cart) updateVisibility(event.detail.cart);
    else refreshVisibility();
  });
})();
